import React from "react";
import Nav from "../Home/Nav/Nav";
import PageTop from "../../common/PageTop/PageTop";
import Footer from "../../common/Footer/Footer";
import Services from "../services/Services";
import aboutimage from '../../../assets/images/ogser.jpg'

const ServicePage = () => {
  return (
    <>
      <Nav />
      <PageTop title={'What We Do'} image={aboutimage}/>
      <Services />
      <Footer />
    </>
  );
};

export default ServicePage;
